"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function useLocalStorageListener(onChange) {
  (0, _react.useEffect)(() => {
    const handleStorageChange = event => {
      if (event instanceof CustomEvent && event.type === 'w-local-storage-change') {
        onChange(event);
      }
    };
    window.addEventListener('w-local-storage-change', handleStorageChange);
    return () => {
      window.removeEventListener('w-local-storage-change', handleStorageChange);
    };
  }, [onChange]);
}
var _default = exports.default = useLocalStorageListener;